
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.683 17.249C5.649 17.249.496 11.056.28.75h4.525c.15 7.564 3.485 10.768 6.128 11.429V.75h4.26v6.524c2.61-.281 5.351-3.254 6.276-6.524h4.262c-.71 4.03-3.683 7.003-5.797 8.225 2.114.99 5.5 3.584 6.788 8.274h-4.69c-1.008-3.138-3.518-5.566-6.838-5.896v5.896h-.512z","fill":"currentColor"}})])
          )
        }
      }
    